<template>
  <div class="whole-country">
    <HeaderTop title="金风科技全国产业布局"></HeaderTop>
    <ul class="map-point-list">
      <li v-for="item in cityList" :key="item.name"
          :class="{'is-active': item.active, 'high-light': item.isHighLight}"
          :style="{ left: item.left + 'vw', top: item.top + 'vh' }"
          @click.stop="cityClick(item)">
        <p class="name">{{ item.name }}</p>
        <span class="point"></span>
        <span class="circle"></span>
      </li>
    </ul>
    <el-button class="go-back" type="text" @click.stop="goBack">
      <i class="el-icon-back"></i>返回
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'country',
  data () {
    return {
      cityList: this.$store.state.page.pageConfig['金风科技全国产业布局']
    }
  },
  components: {
    HeaderTop: () => import("/src/components/HeaderTop")
  },
  methods: {
    goNext () {
      this.$emit('pageNext')
    },
    cityClick (item) {
      if (item.name === '秦皇岛') {
        this.goNext()
      }
    },
    goBack () {
      this.$emit('prev')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/src/assets/css/common.scss";
.whole-country {
  width: 100vw;
  height: 100vh;
  background: url("/resource/img/whole-country.png") no-repeat center / cover;
}
</style>
